export type TApprovalStatusString =
  | "NeedApproval"
  | "Approved"
  | "Rejected"
  | "NoApprovalRequired";

export const getWorkflowStatusColor = (
  approvalStatusString: TApprovalStatusString,
): "warning" | "success" | "error" | "default" => {
  switch (approvalStatusString) {
    case "NeedApproval":
      return "warning";
    case "Approved":
      return "success";
    case "Rejected":
      return "error";
    default:
      return "default";
  }
};
